import { Tree } from 'antd';
import Card from 'antd/es/card';

const treeData = [
  {
    title: 'Меры государственной поддержки',
    key: 'mgp',
    selectable: false,
    children: [
      {
        title: 'Нефинансовые',
        key: 'nonFinancial',
        selectable: false,
        children: [
          {
            title: 'Обучение',
            key: 'education',
            selectable: false,
            children: [
              {
                title: 'Пройденные курсы, мои сертификаты',
                key: 'certificates',
              },
            ],
          },
        ],
      },
      {
        title: 'Финансовые',
        key: 'financial',
        selectable: false,
      },
    ],
  },
  {
    title: 'Отчетность',
    key: 'report',
    selectable: false,
  },
  {
    title: 'Актуальное для бизнеса',
    key: 'actual_business',
    selectable: false,
  },
  {
    title: 'Календарь событий',
    key: 'events_calendar',
    selectable: false,
  },
  {
    title: 'Гос. контроль',
    key: 'gov_control',
    selectable: false,
  },
  {
    title: 'Моя статистика',
    key: 'my_statistics',
    selectable: false,
  },
  {
    title: 'Разрешительные документы',
    key: 'permits',
    selectable: false,
  },
  {
    title: 'Реестр обязательных требований',
    key: 'obligations',
    selectable: false,
  },
];

function ServicesTree() {
  return (
    <Card style={{ height: '100%' }}>
      <div>Услуги</div>
      <Tree treeData={treeData} defaultExpandedKeys={['mgp']} />
    </Card>
  );
}

export default ServicesTree;
